<template>
    <div>

    </div>
</template>

<script>
    import apiUrl from "@/utils/UrlApi"

    export default {
        name: "checkToken",
        computed: {
            quary: {
                get() {
                    return this.$route.query
                }
            },
            type: {
                get() {
                    return this.$route.params.type
                }
            },
            gpsState: {
                get() {
                    return this.$store.state.gpsState;
                },
                set(val) {
                    this.$store.commit('updateGpsState', val);
                }
            },
            userName: {
                get() {
                    return this.$store.getters.getUserName;
                },
                set(val) {
                    this.$store.commit("updateUserName", val);
                }
            },

        },
        methods: {
            checkWeChat(){
                let self = this
                localStorage.setItem('token',this.$route.query.token)
                self.getUserInfo()

                console.log(this.type)

            },
            getUserInfo() {
                let url = apiUrl.ssoLogin
                let self = this
                this.$http.get(url, {
                    params: {
                        token:this.$route.query.token
                    }
                }).then(res => {
                    if (res.data.code === '200') {
                        localStorage.setItem('token', res.data.data.token)
                        localStorage.setItem('userName', res.data.data.userInfo.name)
                        localStorage.setItem('userId', res.data.data.userInfo.userId)

                        self.userName = res.data.data.userInfo.name



                        //  跳转页面参数
                        /**
                         *
                         * 1 成因分析
                         * 2 综合分析
                         * 3 成因分析-案例库
                         * 4 成因分析- 光化学污染
                         *
                         * */


                        switch (this.type) {
                            case '1':
                                this.$router.push({
                                    name:'AirQuality'
                                })
                                break

                            case '2':

                                this.$http.get(apiUrl.roleList, {
                                    params: {}
                                }).then(res => {
                                  let roList =  res.data.data.list
                                    let isRole = false  //  是否有权限
                                    for (let i = 0; i < roList.length; i++) {
                                        if (roList[i].id===1){
                                            isRole = true
                                        }
                                    }

                                    if (isRole){
                                        let datas = {
                                            roleId: 1
                                        }
                                        this.$http.post(apiUrl.setRole, datas
                                        ).then(({data}) => {
                                                if (data.code === '200') {
                                                    this.$router.push({
                                                        name:'VOCSystemHome'
                                                    })
                                                }
                                            }
                                        )
                                    }else {
                                        this.$message.error('没有权限')
                                    }
                                })


                                break
                            case '3':
                                this.$router.push({
                                    name:'showCaseBase'
                                })
                                break
                            case '4':
                                this.$router.push({
                                    name:'showGHX_PollutionLevel',
                                    query:{
                                        id:42,
                                        menuId:200053,
                                        name:'臭氧与前体物时序图'
                                    }
                                })
                                break
                            case '5':
                                this.$router.push({
                                    name:'dataAnalysedHome',
                                })
                                break
                            default:
                                this.$router.push({
                                    name:'AirQuality'
                                })
                        }
                    } else {
                        this.$message.error(res.data.message)
                    }

                })
            },
        },
        mounted() {
            this.checkWeChat()
        }
    }

</script>

<style scoped>

</style>
